module.exports = __webpack_public_path__ + "img/icon-answered_calls_month.cd9e7b13.svg";